import angular from 'angular';

import {user} from '../../user/user.js';
import {UserProfile} from 'acng/user/profile/profile.js';

angular.module('userPool').directive('onswProfileImage', ['$location', 'Widget', 'http', ($location, Widget, http) => {

  return {
    scope: {},
    templateUrl: '/template/userPool.profileImg',
    link: function (scope, element) {

      const widget = new Widget(scope, element, 'ons-form');
      const profile = new UserProfile();

      scope.user = user;
      widget.busy(profile.setup.then(function (data) {
        scope.profile = data;
        scope.currentImage = profile.image;
        element.addClass('ready');
      }).then(function () {
        http().get('/api/userProfile/waiting-images').then(function (res) {
          scope.images = res.data;
        });
      }));

      scope.uploadImage = function () {
        function uploadImage(image) {
          return http().post('api/userProfile/image', image, {
            dontIntercept: true,
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
          });
        }

        if (!scope.image) return;

        scope.busy = true;
        var data = new FormData();
        data.append('image', scope.image);

        widget.busy(uploadImage(data).then(function (res) {
          $location.path('/profile/image/' + res.data.name);
        }).finally(function () {
          scope.busy = false;
        })).catch(function (err) {
          widget.notify(err);
        });
      };
    }
  };
}]);
